import { render } from "./RecipientsBlacklistList.vue?vue&type=template&id=575a94d5"
import script from "./RecipientsBlacklistList.vue?vue&type=script&lang=js"
export * from "./RecipientsBlacklistList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__